import ArtistApplyFormStep from './ArtistFormStep'
import { ArtistFormQuestions, FormInputs } from './ArtistFormStep.types'
import ArtistApplyFormSuccess from './ArtistFormSuccess'

interface ArtistFormContainerProps {
  step: number
  onSubmit: (data: FormInputs) => Promise<unknown>
  questions: ArtistFormQuestions
}

/**
 *
 * @description A component that renders on the page.
 * @param {ArtistFormContainerProps} ArtistFormContainerProps
 *
 */
const ArtistFormContainer = ({
  step,
  onSubmit,
  questions,
}: ArtistFormContainerProps) => {
  switch (step) {
    case 1:
      return <ArtistApplyFormStep onSubmit={onSubmit} questions={questions} />
    case 2:
      return <ArtistApplyFormSuccess />
    default:
      return <ArtistApplyFormStep onSubmit={onSubmit} questions={questions} />
  }
}

export default ArtistFormContainer
